// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T6VK","col":"styles_col__1rEQj","actions":"styles_actions__12c51","conflict":"styles_conflict__2Z5N4"};